export const ETSY_SHOP_URL = process.env.REACT_APP_ETSY_SHOP_URL || "";
export const ETSY_BACH_URL = process.env.REACT_APP_ETSY_BACH_URL || "";

export function goToEtsy(product) {
  const url = product === "bachelorette" && ETSY_BACH_URL ? ETSY_BACH_URL : ETSY_SHOP_URL;
  if (url) window.open(url, "_blank", "noopener,noreferrer");
}
